/**
 * Map registry `resolvedKey` → screen components (v3 UI only).
 */
import type { ComponentType } from 'react';
import { DevToolsScreen } from '../exDev';
import type { ResolvedScreenKey } from '../shared/navigation/types';
import { JourneyScreen } from '../journey/JourneyScreen';
import { JourneyResultScreen } from '../journey/JourneyResultScreen';
import MainScreen from '../onboarding/MainScreen';
import { SubscriptionListScreen } from '../subscriptions/SubscriptionListScreen';
import { ConsultationScreen } from '../consultation/ConsultationScreen';
import { HealthInformationSourcesScreen } from '../healthInformation/HealthInformationSourcesScreen';
import { AboutUsScreen } from '../content/AboutUsScreen';
import GuestMenuPreviewScreen from '../guest/GuestMenuPreviewScreen';
import { TermsAndConditionsScreen } from '../content/TermsAndConditionsScreen';
import { ProfileScreen } from '../customer/ProfileScreen';
import { MySubscriptionsScreen } from '../subscriptions/MySubscriptionsScreen';
import { CheckoutScreen } from '../checkout/CheckoutScreen';
import OrderHistoryScreen from '../orders/OrderHistoryScreen';
import { OrderDetailsScreen } from '../orders/OrderDetailsScreen';
import { SettingsScreen } from '../accounts/SettingsScreen';
import { NotificationsScreen } from '../accounts/NotificationsScreen';
import { LoyaltyScreen } from '../loyalty/LoyaltyScreen';
import AddressListScreen from '../customer/AddressListScreen';
import DeliveryScheduleScreen from '../customer/DeliveryScheduleScreen';
import { CommunityScreen } from '../community/CommunityScreen';
import { NewsScreen } from '../content/NewsScreen';
import { NewsArticleScreen } from '../content/NewsArticleScreen';
import { AddressFormScreen } from '../customer/AddressFormScreen';
import { PaymentWebViewScreen } from '../checkout/PaymentWebViewScreen';
import { OrderCheckoutScreen } from '../orders/OrderCheckoutScreen';
import { UpgradeCheckoutScreen } from '../subscriptions/UpgradeCheckoutScreen';
import { OrderConfirmedScreen } from '../orders/OrderConfirmedScreen';
import { OrderFailedScreen } from '../orders/OrderFailedScreen';
import ResolvedAllergiesDislikesScreen from '../shared/navigation/resolvedAllergiesDislikesScreen';
import ResolvedFoodItemDetailScreen from '../shared/navigation/resolvedFoodItemDetailScreen';
import OrderCustomerDetailsScreen from '../orders/OrderCustomerDetailsScreen';

export const RESOLVED_SCREEN_MAP: Record<ResolvedScreenKey, ComponentType> = {
  Journey: JourneyScreen,
  JourneyResult: JourneyResultScreen,
  Main: MainScreen,
  SubscriptionList: SubscriptionListScreen,
  Consultation: ConsultationScreen,
  HealthInformationSources: HealthInformationSourcesScreen,
  AboutUs: AboutUsScreen,
  GuestMenuPreview: GuestMenuPreviewScreen,
  TermsAndConditions: TermsAndConditionsScreen,
  Profile: ProfileScreen,
  MySubscriptions: MySubscriptionsScreen,
  Checkout: CheckoutScreen,
  OrderHistory: OrderHistoryScreen,
  OrderDetails: OrderDetailsScreen,
  Settings: SettingsScreen,
  DevTools: DevToolsScreen,
  Notifications: NotificationsScreen,
  Loyalty: LoyaltyScreen,
  AddressLists: AddressListScreen,
  DeliverySchedule: DeliveryScheduleScreen,
  Community: CommunityScreen,
  News: NewsScreen,
  NewsArticle: NewsArticleScreen,
  AddressForm: AddressFormScreen,
  FoodItemDetail: ResolvedFoodItemDetailScreen,
  PaymentWebView: PaymentWebViewScreen,
  OrderCheckout: OrderCheckoutScreen,
  UpgradeCheckout: UpgradeCheckoutScreen,
  OrderConfirmed: OrderConfirmedScreen,
  OrderFailed: OrderFailedScreen,
  AllergiesDislikes: ResolvedAllergiesDislikesScreen,
  OrderCustomerDetails: OrderCustomerDetailsScreen,
};

export function getResolvedScreenComponent(key: ResolvedScreenKey): ComponentType {
  return RESOLVED_SCREEN_MAP[key];
}
